module.exports = __webpack_public_path__ + "static/media/Career_Page_Images_Square_03.bfad812c.jpg";